var _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMagicWand(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.52 38.4561C15.832 41.4481 12.568 48.1121 20.32 48.9121C29.216 49.8321 30.032 54.7521 34.72 54.3361C40.824 53.8001 39.152 47.1361 46.24 47.0481C52.808 46.9361 53.336 44.4641 53.24 39.6241C53.088 32.0961 58.112 31.0321 57.536 26.1361C57.224 23.4961 53.304 21.1121 51.472 19.3361C45.872 13.9281 48.552 10.9601 45.608 8.39208C42.664 5.82408 38.288 9.44008 33.864 9.44808C28.104 9.44808 26.04 6.88808 21.616 8.00808C17.192 9.12808 16.504 14.4481 15.2 18.4001C14.072 21.6721 8.74404 23.1521 9.13604 28.7201C9.50404 34.4961 12.48 33.8001 14.52 38.4561Z",
    fill: "#F1F1F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6 36.376C29.6 36.376 10.84 55.576 9.6 56.376C8.8 56.896 7.656 55.48 6.824 54.24C6.53142 53.8042 6.39937 53.2803 6.45044 52.7578C6.50152 52.2354 6.73255 51.7469 7.104 51.376L25.848 32.624",
    stroke: "#00005A",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8479 32.624L31.6079 26.864C33.3679 25.104 37.0079 28.968 35.3599 30.616L29.5999 36.376",
    stroke: "#00005A",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.488 20.7281L22.744 24.9841L23.88 23.8561L19.616 19.6001L18.488 20.7281ZM42.912 20.2881L41.784 19.1521L37.528 23.4081L38.656 24.5441L42.912 20.2881ZM37.168 39.3121L41.424 43.5681L42.552 42.4401L38.296 38.1841L37.168 39.3121ZM41.128 30.8001V32.4001H47.144V30.8001H41.128ZM29.696 20.9761H31.296V14.9601H29.696V20.9761Z",
    fill: "url(#paint0_linear_37529_162350)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8479 32.624L30.2879 35.68",
    stroke: "#00005A",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_37529_162350",
    x1: 38.12,
    y1: 17.2161,
    x2: 27.952,
    y2: 36.4481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FF9793"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FF8AA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FF80B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#FF66D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF44FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#4900FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00005A"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMagicWand);
export default __webpack_public_path__ + "static/media/icon-magic-wand.fa46d418edac3481c4a03a811d7d7ffc.svg";
export { ForwardRef as ReactComponent };